module.exports = __webpack_public_path__ + "img/secA.8f5dd038.png";